import React, { useContext } from "react";
import {
  Button,
  Chip,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { UserListAdvertisementContext } from "../../../../../../../../context/follow-up-widgets";
import PageDomain from "../../../../domain";
import AddIcon from "@material-ui/icons/Add";
import moment from "moment";
import { usePublish } from "../../../../../../../../hooks/publisher-subscriber";
import Config from "../../../../domain/config";
import { isEmpty } from "lodash";
import AppConfig from "../../../../../../../../config";

const { FOLLOW_UP_COMMENTS_BLOCKED_POST_STATUSES } = AppConfig;

const FollowupCommentsTabView = () => {
  const {
    advertisement,
    advertisement: { comments = [] },
  } = useContext(UserListAdvertisementContext);
  const publish = usePublish();

  const sortedTableData = comments.sort((a, b) => {
    return moment(b.createdAt).diff(a.createdAt);
  });

  return (
    <Grid container direction="column" className="follow-up-comments-tab-view">
      <Button
        startIcon={<AddIcon />}
        className="add-comment-btn"
        disabled={FOLLOW_UP_COMMENTS_BLOCKED_POST_STATUSES.includes(
          advertisement?.post?.status,
        )}
        onClick={() => {
          const { SIDE_VIEW_VARAIENT } = Config;
          publish("openSideView", {
            currentView: SIDE_VIEW_VARAIENT.addFollowUpComment,
            advertisement,
          });
        }}
      >
        Add Comment
      </Button>
      <Grid
        container
        direction="row"
        className="payment-history-tab-content tab-content"
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>created At</TableCell>
                <TableCell align="right">Comment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(sortedTableData) ? (
                <TableRow>
                  <TableCell align="center" colSpan={2}>
                    <Typography variant="caption">
                      No Records Available
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                sortedTableData.map((row) => (
                  <TableRow key={row.name}>
                    <TableCell className="gap-y-16">
                      <Typography
                        variant="body2"
                        className="gap-x-16"
                        style={{ display: "flex" }}
                      >
                        {PageDomain.formatDateAndTime(row.createdAt)}
                        {row.postStatus === "EXPIRED" && (
                          <Chip label="exp" className="expired-comment-tag" />
                        )}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">{row.comment}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default FollowupCommentsTabView;
